import Button from "@mui/material/Button";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";

import { useQueryClient } from "@tanstack/react-query";
import { useCreateResource } from "../../shared/hooks/useCreateResources";
import { useUpdateDoctypeData } from "../../shared/hooks/useDocTypesData";
import StyledDropzone from "./StyledDropzone";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    paper: {
        backgroundColor: "#ffffff", // Background color
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)", // Box shadow
        padding: "16px", // Padding (16px top, 16px right, 16px bottom)
    },
    formControl: {
        marginBottom: "24px", // Margin bottom
    },
    progressBar: {
        marginBottom: "16px", // Margin bottom
    },
}));

const CreateResourceModal = ({
    onClose,
    onCreated,
    doctype,
    docname,
    fieldname = null,
}) => {
    const classes = useStyles();
    const queryClient = useQueryClient();

    const [name, setName] = useState("Initial");
    const [file, setFile] = useState(null);
    const [isCreating, setIsCreating] = useState(false);

    const createResource = useCreateResource();
    const updateResource = useUpdateDoctypeData();

    const onDrop = (acceptedFiles) => {
        setFile(acceptedFiles);
    };

    const handleCreateResource = async () => {
        setIsCreating(true);
        const data = await createResource.mutateAsync(
            {
                file,
                name,
                docname: docname, // model.item_code,
                doctype,
                fieldname,
            },
            {
                onSuccess: (data) => {
                    const {
                        doctype,
                        attached_to_name: name,
                        file_url: fileUrl,
                    } = data;
                    // const fileUrl = attachments.slice(-1)?.[0]?.file_url;

                    updateResource.mutate(
                        {
                            doctype: "Restaurant Object",
                            name: docname,
                            formData: {
                                floor_plan: fileUrl,
                            },
                        },
                        {
                            onSuccess: () => {
                                //TODO NOTIFY
                                queryClient.refetchQueries([
                                    "getTableOrdersData",
                                ]);
                            },
                            onSettled: () => {
                                setIsCreating(false);
                            },
                            onError: (err) => {
                                console.log("err : ", err);
                            },
                        }
                    );
                },
            }
        );
        onCreated && onCreated(data);
        setIsCreating(false);
        onClose && onClose();
    };

    useEffect(() => clearState(), []);

    const clearState = () => {
        setName("");
        setFile(null);
        setIsCreating(false);
    };

    return (
        <div className={classes.paper}>
            <Typography variant="h5">Change Room Background Image</Typography>
            <StyledDropzone
                accept={"image/*"}
                loading={isCreating}
                onDrop={onDrop}
                file={file}
            />
            {isCreating && (
                <div className={classes.progressBar}>
                    <LinearProgress />
                </div>
            )}
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px", // Adjust this value as needed
                }}
            >
                <div>&nbsp;&nbsp;</div>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleCreateResource}
                    disabled={isEmpty(file) || isCreating}
                >
                    {isCreating ? "Uploading.." : "Upload"}
                </Button>
            </div>
        </div>
    );
};

export default CreateResourceModal;
